export default __webpack_public_path__ + "7dfeb84c9f6c42c261266f7a743fa312.png";